/* @flow */
import React, { Component } from "react";
import styled from "styled-components";
import StockMenu from "../StockMenu";
import Fade from "../common/Animations/Fade";

import type { State as ReduxState } from "../../redux/reducer";

const Container = styled.div`
  position: relative;
  display: inline-block;
  vertical-align: middle;
  margin-left: 10px;
`;

const AddTabView = styled.button`
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  background-color: transparent;
  border: 1px solid ${props => props.theme.mainSeparator};
  cursor: pointer;

  :hover {
    background-color: ${props => props.theme.mainLight};
  }

  :hover > div {
    background-color: ${({ theme }) => theme.foreground};
  }
`;

const Line = styled.div`
  position: absolute;
  background-color: ${({ theme }) => theme.textMuted};
`;

const HLine = styled(Line)`
  top: 14px;
  left: 5px;
  width: 20px;
  height: 2px;
`;

const VLine = styled(Line)`
  top: 5px;
  left: 14px;
  width: 2px;
  height: 20px;
`;

const Menu = styled.div`
  position: absolute;
  top: 32px;
  left: 0px;
  background-color: ${props => props.theme.mainDark};
  z-index: 10;
`;

const InlineBlock = styled.div`
  display: flex;
  width: 100%;
  height: 450px;
  padding: 12px;
  background-color: ${props => props.theme.popupBackground};
  z-index: 1;
  overflow: hidden;
`;

type Props = {
  tabs: $PropertyType<ReduxState, "tabs">,
  onNewTab: (stock: string) => void,
  onNextActiveTab: (tab: number) => void
};

type State = {
  shouldShowMenu: boolean
};

class AddTab extends Component<Props, State> {
  state: State = {
    shouldShowMenu: false
  };

  toggleMenu = () => {
    this.setState({
      shouldShowMenu: !this.state.shouldShowMenu
    });
  };

  handleOutsideClick = e => {
    if (e && typeof e.preventDefault === "function") {
      e.preventDefault();
      e.stopPropagation();
    }

    this.setState({
      shouldShowMenu: false
    });
  };

  handleStockSelection = (stock: string) => {
    this.toggleMenu();

    const tabIndex = this.props.tabs.tabs.indexOf(stock);

    if (tabIndex === -1) {
      this.props.onNewTab(stock);
    } else {
      this.props.onNextActiveTab(tabIndex);
    }
  };

  render() {
    return (
      <Container>
        <AddTabView onClick={this.toggleMenu}>
          <HLine />
          <VLine />
        </AddTabView>
        <Fade in={this.state.shouldShowMenu}>
          {({ style }) => (
            <Menu style={style}>
              <InlineBlock>
                <StockMenu
                  onStockSelect={this.handleStockSelection}
                  onClose={this.handleOutsideClick}
                />
              </InlineBlock>
            </Menu>
          )}
        </Fade>
      </Container>
    );
  }
}

export default AddTab;



// WEBPACK FOOTER //
// ./src/components/Tabs/AddTab.js